import type { RouteRecordRaw } from 'vue-router'
import { ROUTES } from '@/router/routes.enum'
import { ACTION_ROLES } from '@/utils/constants'
import { requireAuthenticatedUser } from '@/router/guards'

export const printedTicketRoutes: RouteRecordRaw[] = [
  {
    path: '/printed-tickets',
    name: ROUTES.PRINTED_TICKETS,
    component: () => import('@/modules/printed-tickets/views/PrintedTicketListing.view.vue'),
    beforeEnter: requireAuthenticatedUser,
    meta: { roles: ACTION_ROLES.PRINTED_TICKETS_VIEW }
  },
  {
    path: '/printed-tickets/:id',
    name: ROUTES.PRINTED_TICKET_DETAILS,
    component: () => import('@/modules/printed-tickets/views/PrintedTicketDetails.view.vue'),
    beforeEnter: requireAuthenticatedUser,
    meta: { roles: ACTION_ROLES.PRINTED_TICKET_DETAILS_VIEW }
  }
]
